var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.plotlyData.length)?_c('plotly-graph',{key:_vm.plotlyCounter,ref:"plotlyGraph",attrs:{"data":_vm.plotlyData,"config":_vm.plotlyConfig,"layout":_vm.chartLayout},on:{"click":_vm.markerClickHandler,"hover":_vm.hoverHandler}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }